export class Configuration {
  static get() {
    if (window.location.hostname.indexOf('10.20.30') > -1) {
      return {
        apiBackend: 'http://10.20.30.40/service/',
        headerToken: 'X-AUTH-TOKEN',
      }
    }
    else if (window.location.hostname.indexOf('localhost') > -1) {
      return {
        apiBackend: 'http://localhost:8400/service/',
        headerToken: 'X-AUTH-TOKEN',
      }
    } else {
      return {
        apiBackend: '/service/',
        headerToken: 'X-AUTH-TOKEN',
      }
    }
  }
  static profile() {
      return {
        nama:'RSUD MANGUSADA',
        namaPPK:'RSD MANGUSADA KABUPATEN BADUNG',
        alamat: 'Jl. Raya Kapal, Mangupura, Mengwi, Kapal, Kec. Mengwi, Kabupaten Badung, Bali 80351',
        link: 'https://drive.google.com/file/d/1GCx6WDTTykrGWSFIa6S6guVGRqZR9uQ1/view?usp=sharing',
        kdRekananBPJS:2552,
        kdKelompokBPJS:2,
      }
    
  }
}
